export const carlist = [
  {
    id: 1,
    name: 'Vehicle',
    nameAr: 'المركبة',
  },
  {
    id: 2,
    name: 'Reg No',
    nameAr: 'رقم التسجيل',
  },
  {
    id: 3,
    name: 'Date Out',
    nameAr: 'تاريخ الخروج',
  },
  {
    id: 4,
    name: 'Time Out',
    nameAr: 'وقت الخروج',
  },
  {
    id: 5,
    name: 'Date In',
    nameAr: 'تاريخ العودة',
  },
  {
    id: 6,
    name: 'Time In',
    nameAr: 'وقت العودة',
  },
  {
    id: 7,
    name: 'Km OUT',
    nameAr: 'العداد وقت الخروج',
  },
  {
    id: 8,
    name: 'Km IN',
    nameAr: 'العداد وقت العودة',
  },
  {
    id: 9,
    name: 'Km Driven',
    nameAr: 'المسافة المقطوعة',
  },
  {
    id: 10,
    name: 'Insurance',
    nameAr: 'التأمين',
  },
];

export const custlist = [
  {
    id: 1,
    name: 'Name',
    nameAr: 'الاسم',
  },
  {
    id: 1.5,
    name: 'Department',
    nameAr: 'الشركة',
  },
  {
    id: 2,
    name: 'Address',
    nameAr: 'العنوان',
  },
  {
    id: 4,
    name: 'Tel',
    nameAr: 'هاتف',
  },
  {
    id: 5,
    name: 'Driver Name',
    nameAr: 'اسم السائق',
  },
  {
    id: 6,
    name: 'License No',
    nameAr: 'رخصة القيادة',
  },
  {
    id: 8,
    name: 'Expire Date',
    nameAr: 'تاريخ الانتهاء',
  },
  {
    id: 9,
    name: 'Nationality',
    nameAr: 'الجنسية',
  },
  {
    id: 10,
    name: 'ID No',
    nameAr: 'البطاقة الشخصية',
  },
  {
    id: 12,
    name: 'Expire Date',
    nameAr: 'تاريخ الانتهاء',
  },
];
